export default "__VITE_ASSET__PFIKrKuk__"